export type PartnerSessionErrorReason =
  | 'invalid_token'
  | 'expired_token'
  | 'rejected_token'
  | 'unauthorized';

const allowedReasons: PartnerSessionErrorReason[] = [
  'invalid_token',
  'expired_token',
  'rejected_token',
  'unauthorized',
];

export const getPartnerSessionErrorPath = (
  reason: PartnerSessionErrorReason,
  currentPathname: string | undefined = window.location.pathname,
): string => {
  const devstackPrefix = (currentPathname || '').match(
    /^\/(pr|commit)\/[^/]+/,
  )?.[0];
  return `${devstackPrefix ?? ''}/partner-session-error?reason=${reason}`;
};

export const parsePartnerSessionErrorReason = (
  value: string | null,
): PartnerSessionErrorReason => {
  return allowedReasons.includes(value as PartnerSessionErrorReason)
    ? (value as PartnerSessionErrorReason)
    : 'rejected_token';
};
